import AppLayout from 'components/layout/layout'
import React, { useEffect, useState } from 'react'
import { Tabs } from 'antd'
import TeamPageHeader from './Header/TeamPageHeader'
import TableView from './Views/TableView'
import { GetAllTeamsParams } from 'types/team/team'
import { useGetAllTeams } from 'api/Team/Team'
import Spinner from 'components/Spinner'
import { teamStore } from 'state/team/team'
import CreateTeam from './Modals/CreateTeam'

const { TabPane } = Tabs

const Teams: React.FC = () => {
  const { teamModalVisible } = teamStore(store => ({
    teamModalVisible: store.teamModalVisible,
  }))
  const [params, setParams] = useState<GetAllTeamsParams>({
    page: 1,
    limit: 10,
    status: 'active',
  })
  const { data, isLoading, isFetching, refetch } = useGetAllTeams(params)

  useEffect(() => {
    refetch()
  }, [params, refetch])

  const onTabChange = (key: string) => {
    setParams(prev => ({ ...prev, status: key as 'active' | 'archived', page: 1 }))
  }

  const tableContent =
    isLoading || isFetching ? (
      <div className="flex justify-center py-20px w-full">
        <Spinner />
      </div>
    ) : (
      <TableView data={data} params={params} setParams={setParams} refetch={refetch} />
    )

  return (
    <>
      <AppLayout>
        <div className="px-40px py-40px">
          <TeamPageHeader />
          <div className="mt-20px">
            <Tabs activeKey={params.status} onChange={onTabChange}>
              <TabPane tab="Active" key="active">
                {tableContent}
              </TabPane>
              <TabPane tab="Archived" key="archived">
                {tableContent}
              </TabPane>
            </Tabs>
          </div>
        </div>
      </AppLayout>
      {teamModalVisible && <CreateTeam />}
    </>
  )
}

export default Teams
